export default __webpack_public_path__ + "static/media/gallery_00.e2ded5d6.jpg";